/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import AnimationModel from '../element-modeles/anim-model';
import { SequenceTypes } from '@tencent/slide-sdk-model';
import { transaction, IObservableArray, observable } from 'mobx';
import type SlideModel from '@src/slide/domain/ui-model/element-modeles/slide-model';
import ShapeModel from '@src/slide/domain/ui-model/element-modeles/shape-model';

import type TimingModel from '../element-modeles/timing-model';
import { IAnimListItem } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';

export const isInvalid = (seqTnMap, animList) => (
    !seqTnMap || !animList
);

export const animListToAnimMap = (animList) => {
    const animMap: any = {};
    animList.forEach((animListItem: AnimListItem) => {
        animMap[animListItem.clickSpid] = Object.assign({}, animListItem, {
            data: [...animListItem.data],
        });
    });
    return animMap;
};

const animMapToAnimList = animMap => Object.values(animMap);

export class AnimListItem implements IAnimListItem {
    sequenceTypes: string;
    data: IObservableArray<AnimationModel> = observable([]);
    clickSpid = '';
    constructor(animConf) {
        Object.assign(this, animConf);
    }
}

/**
 *  动画数据convert-handler.js
 */
class AnimHandler {
    baseModel: TimingModel;
    constructor(baseModel) {
        this.baseModel = baseModel;
    }

    /**
     * 可能存在第一个动画是 widthEffect 的情况
     */
    static handleFirstAnim(mainSeqIndex, actionSequence, firstAnimIsWithEffect) {
        const { startCon } = actionSequence;
        if (mainSeqIndex === 0 && (startCon === 'withEffect' || startCon === 'afterEffect')) {
            return true;
        }
        return firstAnimIsWithEffect;
    }

    /**
     * 与 sdk 返回的动画数据进行对比
     * @param {Object} seqTnMap sdk返回数据
     * @param {Array} animList 当前动画队列
     * @param {SlideModel} uiData 当前 slideModel
     */
    static findAndConvertDataSdkToUi(seqTnMap, animList: AnimListItem[], uiData: SlideModel) {
        const animMapNeedToRemove = animListToAnimMap(animList);
        const animListUpdatedBySeqTnMap: AnimListItem[] = [];
        const handlerAllKindOfSeqTn = (sequenceTypes) => {
            if (!seqTnMap[sequenceTypes]) return;
            seqTnMap[sequenceTypes].forEach((actionSequenceArr) => {
                const animListItem: AnimListItem = new AnimListItem({ sequenceTypes, data: [], clickSpid: '' });
                let firstAnimIsWithEffect = false;
                actionSequenceArr.forEach((actionSequence, mainSeqIndex) => {
                    animListItem.clickSpid = actionSequence.clickSpid;
                    firstAnimIsWithEffect = AnimHandler.handleFirstAnim(
                        mainSeqIndex,
                        actionSequence,
                        firstAnimIsWithEffect,
                    );
                    actionSequence.animList.forEach((sdkAnimModel) => {
                        // 从现有的动画队列中查找是否已经存在，并更新 data、执行顺序
                        const oldAnimList = animMapNeedToRemove[animListItem.clickSpid];
                        const animIsFounded = oldAnimList?.data
                            .find((animModel: AnimationModel, index) => {
                                if (animModel.sdkData?.id === sdkAnimModel.anim.id) {
                                    AnimHandler.handleUpdateForSdkToUi(
                                        animModel, sdkAnimModel, uiData,
                                        animListItem.data, firstAnimIsWithEffect, mainSeqIndex,
                                    );
                                    oldAnimList.data.splice(index, 1);
                                    return true;
                                }
                                return false;
                            });
                        // 如果不存在，则新增到动画队列中
                        if (!animIsFounded) {
                            AnimHandler.handleUpdateForSdkToUi(
                                null,
                                sdkAnimModel,
                                uiData, animListItem.data,
                                firstAnimIsWithEffect, mainSeqIndex,
                            );
                        }
                    });
                });
                animListUpdatedBySeqTnMap.push(animListItem);
            });
        };

        handlerAllKindOfSeqTn(SequenceTypes.MAIN_SEQ);
        handlerAllKindOfSeqTn(SequenceTypes.INTERACTIVE_SEQ);

        return {
            animListUpdatedBySeqTnMap,
            animListNeedToRemove: animMapToAnimList(animMapNeedToRemove),
        };
    }

    static convertDataSdkToUi(sdkData, uiData, rawSdk) {
        const seqTnMap = rawSdk.getAllKindsOfSequence();
        const { animList } = uiData;
        if (isInvalid(seqTnMap, animList)) return;
        const {
            animListUpdatedBySeqTnMap,
            animListNeedToRemove,
        } = AnimHandler.findAndConvertDataSdkToUi(seqTnMap, animList, uiData);
        animListNeedToRemove
            .forEach(({ data }: AnimListItem) => data.forEach((anim: AnimationModel) => anim.unbindSDK()));

        transaction(() => {
            animList.clear() && animList.push(...animListUpdatedBySeqTnMap);
            // 更新各个 shape 上的 animList
            uiData.children.forEach((shape: ShapeModel) => {
                (shape.animList as IObservableArray<AnimationModel>).clear();
                uiData.animList.forEach((animListItem: AnimListItem) => {
                    animListItem.data?.forEach((animModel: AnimationModel) => {
                        animModel.spid === shape.id && shape.animList?.push(animModel);
                    });
                });
            });
        });
    }

    static handleUpdateForSdkToUi(animModel, sdkAnimModel, uiData, newAnimList, firstAnimIsWithEffect, mainSeqIndex) {
        const sdkAnim = sdkAnimModel.anim;
        const uiModel = animModel || new AnimationModel();
        uiModel.spid = sdkAnimModel.spid;
        uiModel.parent = uiData;
        uiModel.selectionService = uiData.selectionService;
        uiModel.order = firstAnimIsWithEffect ? mainSeqIndex : mainSeqIndex + 1;
        uiData.children.find(child => (child.id === uiModel.spid ? uiModel.elementModel = child : false));
        uiModel.sdkData !== sdkAnim && uiModel.bindSDK(sdkAnim);
        newAnimList.push(uiModel);
    }
}

export default AnimHandler;
